import React from 'react';
import DashboardSection from 'components/DashboardSection';
import Head from 'next/head';
import { requireAuth } from 'util/auth';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'components/sharedCode/components/customTheme';

function DashboardPage(props) {
    return (
        <>
            <Head>
                <meta name="robots" content="noindex,nofollow" />
            </Head>
            <ChakraProvider
                theme={theme}
                //portalZIndex={40} //DONT COMMENT IN = BREAKS TOAST
                toastOptions={{
                    motionVariants: {
                        initial: { y: 40 },
                        animate: { y: 0, opacity: 1 },
                        exit: {
                            opacity: 0,
                            y: 25,
                            transition: { duration: 0.3, ease: 'easeIn' }
                        }
                    }
                }} /* cssVarsRoot="#newtab" */
            >
                <DashboardSection />
            </ChakraProvider>
        </>
    );
}
DashboardPage.isFullPage = true;

export default requireAuth(DashboardPage);
